import TextInput from '../../../Components/Form/Inputs/TextInput';
import ActionModal from '../../../Components/Modals/ActionModal/ActionModal';
import useLanguage from '../../../Services/Language/useLanguageHook';

interface CustomCalculatorModalsProperties {
    isAddCalculatorNameModalOpen: boolean;
    pendingCalculatorName: string;
    onPendingCalculatorNameChange: (value: string) => void;
    onConfirmSaveAs: () => void;
    onCancelSaveAs: () => void;
    isRenameCalculatorModalOpen: boolean;
    pendingRenameCalculatorName: string;
    onPendingRenameCalculatorNameChange: (value: string) => void;
    onConfirmRename: () => void;
    onCancelRename: () => void;
    isDeleteCalculatorModalOpen: boolean;
    deleteCalculatorName: string | undefined;
    onConfirmDelete: () => void;
    onCancelDelete: () => void;
    isCreateCalculatorModalOpen: boolean;
    pendingCreateCalculatorName: string;
    onPendingCreateCalculatorNameChange: (value: string) => void;
    onConfirmCreate: () => void;
    onCancelCreate: () => void;
}

const CustomCalculatorModals = (properties: CustomCalculatorModalsProperties): JSX.Element => {
    const [translations] = useLanguage();

    return (
        <>
            {properties.isAddCalculatorNameModalOpen && (
                <ActionModal
                    header={translations.actions.saveAs}
                    showModal={properties.isAddCalculatorNameModalOpen}
                    actionButtonName={translations.actions.save}
                    actionButtonDisabled={!properties.pendingCalculatorName.trim()}
                    handleAction={properties.onConfirmSaveAs}
                    handleCancel={properties.onCancelSaveAs}
                    track={{ eventCategory: 'MarginCalculator', eventAction: 'SaveAs' }}
                >
                    <TextInput
                        title={translations.words.name}
                        value={properties.pendingCalculatorName}
                        handleTextChange={properties.onPendingCalculatorNameChange}
                        required
                        track={{ eventCategory: 'MarginCalculator', eventAction: 'SaveAsNameInput' }}
                    />
                </ActionModal>
            )}
            {properties.isRenameCalculatorModalOpen && (
                <ActionModal
                    header={translations.risk.margin.headers.customCalculatorRename}
                    showModal={properties.isRenameCalculatorModalOpen}
                    actionButtonName={translations.actions.save}
                    actionButtonDisabled={!properties.pendingRenameCalculatorName.trim()}
                    handleAction={properties.onConfirmRename}
                    handleCancel={properties.onCancelRename}
                    track={{ eventCategory: 'MarginCalculator', eventAction: 'Rename' }}
                >
                    <TextInput
                        title={translations.words.name}
                        value={properties.pendingRenameCalculatorName}
                        handleTextChange={properties.onPendingRenameCalculatorNameChange}
                        required
                        track={{ eventCategory: 'MarginCalculator', eventAction: 'RenameNameInput' }}
                    />
                </ActionModal>
            )}
            {properties.isDeleteCalculatorModalOpen && (
                <ActionModal
                    header={translations.risk.margin.headers.customCalculatorDelete}
                    showModal={properties.isDeleteCalculatorModalOpen}
                    actionButtonName={translations.actions.delete}
                    handleAction={properties.onConfirmDelete}
                    handleCancel={properties.onCancelDelete}
                    track={{ eventCategory: 'MarginCalculator', eventAction: 'DeleteConfirmation' }}
                >
                    <p>
                        {translations.risk.margin.messages.customCalculatorConfirmDelete}
                        {properties.deleteCalculatorName ? ` ${properties.deleteCalculatorName}` : ''}
                    </p>
                </ActionModal>
            )}
            {properties.isCreateCalculatorModalOpen && (
                <ActionModal
                    header={translations.risk.margin.headers.customCalculatorCreate}
                    showModal={properties.isCreateCalculatorModalOpen}
                    actionButtonName={translations.actions.save}
                    actionButtonDisabled={!properties.pendingCreateCalculatorName.trim()}
                    handleAction={properties.onConfirmCreate}
                    handleCancel={properties.onCancelCreate}
                    track={{ eventCategory: 'MarginCalculator', eventAction: 'CreateCalculator' }}
                >
                    <TextInput
                        title={translations.words.name}
                        value={properties.pendingCreateCalculatorName}
                        handleTextChange={properties.onPendingCreateCalculatorNameChange}
                        required
                        track={{ eventCategory: 'MarginCalculator', eventAction: 'CreateCalculatorNameInput' }}
                    />
                </ActionModal>
            )}
        </>
    );
};

export default CustomCalculatorModals;
